export default "__VITE_ASSET__DwukGcrU__"